import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppNoBranches.';
  public static readonly pageTitle = `${Id.prefix}pageTitle`;
  public static readonly noBranchesTitle = `${Id.prefix}noBranchesTitle`;
  public static readonly noBranchesMessage = `${Id.prefix}noBranchesMessage`;
  public static readonly whatYouCanDo = `${Id.prefix}whatYouCanDo`;
  public static readonly stepContactAdminTitle = `${Id.prefix}stepContactAdminTitle`;
  public static readonly stepContactAdminDetail = `${Id.prefix}stepContactAdminDetail`;
  public static readonly stepGoToSettingsTitle = `${Id.prefix}stepGoToSettingsTitle`;
  public static readonly stepGoToSettingsDetail = `${Id.prefix}stepGoToSettingsDetail`;
  public static readonly stepGoToSettingsLink = `${Id.prefix}stepGoToSettingsLink`;
  public static readonly stepLogoutTitle = `${Id.prefix}stepLogoutTitle`;
  public static readonly stepLogoutDetail = `${Id.prefix}stepLogoutDetail`;
  public static readonly whyThisHappens = `${Id.prefix}whyThisHappens`;
}

export class LangAppNoBranches {
  private constructor() {}

  public static pageTitle(): string {
    return interpolate(Id.pageTitle);
  }

  public static noBranchesTitle(): string {
    return interpolate(Id.noBranchesTitle);
  }

  public static noBranchesMessage(): string {
    return interpolate(Id.noBranchesMessage);
  }

  public static whatYouCanDo(): string {
    return interpolate(Id.whatYouCanDo);
  }

  public static stepContactAdminTitle(): string {
    return interpolate(Id.stepContactAdminTitle);
  }

  public static stepContactAdminDetail(): string {
    return interpolate(Id.stepContactAdminDetail);
  }

  public static stepGoToSettingsTitle(): string {
    return interpolate(Id.stepGoToSettingsTitle);
  }

  public static stepGoToSettingsDetail(): string {
    return interpolate(Id.stepGoToSettingsDetail);
  }

  public static stepGoToSettingsLink(): string {
    return interpolate(Id.stepGoToSettingsLink);
  }

  public static stepSignOutTitle(): string {
    return interpolate(Id.stepLogoutTitle);
  }

  public static stepSignOutDetail(): string {
    return interpolate(Id.stepLogoutDetail);
  }

  public static whyThisHappens(): string {
    return interpolate(Id.whyThisHappens);
  }
}

export class AppNoBranchesModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.pageTitle,
      "No available {{glossary 'branch:plural'}}",
      'Browser tab title for the no-branches page'
    );
    register.add(
      Id.noBranchesTitle,
      "No {{glossary 'branch:plural'}} available",
      'Main heading when the user has no available branches'
    );
    register.add(
      Id.noBranchesMessage,
      "You are logged in, but there are no {{glossary 'branch:plural'}} you can access right now. At least one available {{glossary 'branch'}} is required to continue.",
      'Supporting explanation under the no-branches heading'
    );
    register.add(Id.whatYouCanDo, 'What you can do', 'Section heading for recovery steps on the no-branches page');
    register.add(
      Id.stepContactAdminTitle,
      'Contact your administrator',
      'Step 1 title: contact admin for branch access'
    );
    register.add(
      Id.stepContactAdminDetail,
      "Your administrator can assign a {{glossary 'branch'}} to your account, or reactivate a deactivated {{glossary 'branch'}}, so you can continue working.",
      'Step 1 detail: what the admin should do'
    );
    register.add(
      Id.stepGoToSettingsTitle,
      "Reactivate a deactivated {{glossary 'branch'}}",
      'Step 1 title for Staff Admin: recover by opening Settings'
    );
    register.add(
      Id.stepGoToSettingsDetail,
      "Open Settings and reactivate a deactivated {{glossary 'branch'}} assigned to you. Once a {{glossary 'branch'}} is active again, you can continue working.",
      'Step 1 detail for Staff Admin: how to recover from Settings'
    );
    register.add(Id.stepGoToSettingsLink, 'Go to Settings', 'Link text that opens Settings from the no-branches page');
    register.add(Id.stepLogoutTitle, 'Logout and try another account', 'Step 2 title: logout option');
    register.add(
      Id.stepLogoutDetail,
      'If you meant to use a different login, Logout and then Login with the correct account.',
      'Step 2 detail: when to switch accounts'
    );
    register.add(
      Id.whyThisHappens,
      "This usually means every {{glossary 'branch'}} assigned to you is deactivated, or none have been assigned yet. Pages that require a {{glossary 'branch'}} stay locked until access is restored.",
      'Footer note explaining common causes of the no-branches state'
    );
  }
}
